import { render, staticRenderFns } from "./tenantuser.vue?vue&type=template&id=5e57480e&"
import script from "./tenantuser.vue?vue&type=script&lang=ts&"
export * from "./tenantuser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tenantuser.vue"
export default component.exports